import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MxVideoPlayer from 'mx-video-player';
import Timecode from 'mx-video-timecode';
import classNames from 'classnames';

import * as util from './util';
import {Config, LogoUrl} from '../../util';

class LiveImageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: '',
      url: '',
      live: false,
      videoCurrentTime: '',
      videoItem: props.videoItem,
      prevItem: props.videoItem,
      volumeFlag: false,
      startFromSec: 0
    };

    this.canvas = createRef();

    // this.startFromSec = 0;
    
    this.DROW_TIMER = undefined;


  }

  componentDidMount(){
    // clearInterval(this.DROW_TIMER);
    // this.addToCanvas();
  }

  componentWillUnmount(){
    // clearInterval(this.DROW_TIMER);
  }
  componentWillReceiveProps(nextProps, nextState){
    if(JSON.stringify(this.props.videoItem) !== JSON.stringify(nextProps.videoItem)) {
      this.setState({
        videoItem: nextProps.videoItem,
        startFromSec: 0 // mesc 초기화
      });
    }else{
      // mesc 비교
      if(this.state.videoItem.local_msec === this.state.prevItem.local_msec){
          this.setState({
              startFromSec: this.state.startFromSec+1
          })
        }
    }
  }

  addToCanvas() {
    
    const canvas = this.canvas.current;
    const {videoItem, prevItem} = this.state;
    const src = `${videoItem.addr}/${videoItem.jpg}`;
    
    // 2d모드의 그리기 객체를 취득한다. => 이 객체를 통해 canvas에 그림을 그릴 수 있다.
    if(canvas){
      let ctx = canvas.getContext("2d");
      let image = new Image();
      image.src = src;
      
      let test = true;
      // image.onload = function () {
        this.DROW_TIMER = setInterval(()=> {
          ctx.drawImage(image, 0, 0);
          if (test) image.src = `${videoItem.addr}/${prevItem.jpg}`;
          else image.src = src;
          test = !test;
        }, 1/30 * 1000);
        setTimeout(()=> {
          clearInterval(this.DROW_TIMER)
        }, 900);
        
      // }

    }
    
  };



 


  render() {
    const {
      startTimeSec,
      videoCurrentTime,
      videoInfo,
      startFromSec,
      videoItem
    } = this.state;

    let {
      id,
      videoTotalCount,
      // videoItem
    } = this.props;


    // const channelImage = LogoUrl(videoItem.chname);
    const channelImage = videoItem.chName ? _.keyBy(Config.logoUrl, 'title')[videoItem.chName] : '';
    const src = `${videoItem.addr}/${videoItem.jpg}`;

    let statusName;
    switch(videoItem.status){
      case 1024:
      case 1280:
        statusName = "녹화중";
      break;
      case 0:
      case 1:
      case 256:
      case 512:
      case 768:
      case 1536:
        statusName = "녹화대기";
      break;
      default:
        statusName = "녹화오류";
      break;
    }
    if(startFromSec >= 5) statusName = "녹화오류";
    
    return (
      <div className={classNames("item", {
          "four_total" : videoTotalCount >= 1 && videoTotalCount < 4  // 채널 4개까지
        },{
          "six_total" : videoTotalCount >= 4 && videoTotalCount < 6  // 채널 6개까지
        },{
          "nine_total" : videoTotalCount >= 6 && videoTotalCount < 9  // 채널 9개까지
        },
        {
          "total" : videoTotalCount >= 9  // 채널 9개 이상
        }
        )}>
        <div className="video">
          {startFromSec >= 5 ?
            <div></div>
          :
            <img src={src} alt={videoItem.chName} />
          }
          {/* <canvas ref={this.canvas} width="426" height="240"></canvas> */}
        </div>
        <div className="info">
          <img src={channelImage && channelImage.imgBlack} alt={channelImage && channelImage.title} />
          <div className="live">{statusName}</div>
          {/* {live ? <div className="live">LIVE</div> : <div className="time">{videoCurrentTime}</div>}
          <div className="date">{airDate}</div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedMenu: state.selectedMenu,
  }
};

LiveImageItem = connect(mapStateToProps)(LiveImageItem);


export default LiveImageItem;


// WEBPACK FOOTER //
// ./src/components/video/LiveImageItem.js